import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getAgentResponse, updateAgentResponse } from "../api/agentResponseApi";
import { AGENT_RESPONSE_STEPS } from "../utils/agentResponseOptions";
import { useDesk } from "./useDesk";

export function useAgentResponse(sectionKey) {
  const { id } = useParams();
  const navigate = useNavigate();
  const desk = useDesk();
  const [response, setResponse] = useState(null);

  useEffect(() => {
    getAgentResponse(id).then(setResponse);
  }, [id]);

  const stepIndex = AGENT_RESPONSE_STEPS.findIndex((step) => step.key === sectionKey);

  async function saveSection(sectionData) {
    const payload = sectionKey === "property" ? { property: sectionData } : { [sectionKey]: sectionData };
    const next = await updateAgentResponse(id, payload);
    setResponse(next);
    return next;
  }

  function goNext() {
    const next = AGENT_RESPONSE_STEPS[stepIndex + 1];
    navigate(next ? desk.responsePath(id, next.path) : desk.responses);
  }

  function goBack() {
    const prev = AGENT_RESPONSE_STEPS[stepIndex - 1];
    navigate(prev ? desk.responsePath(id, prev.path) : desk.responses);
  }

  return { id, response, setResponse, saveSection, goNext, goBack, stepIndex, desk };
}
